export default __webpack_public_path__ + "static/media/iabon.3de099ab.png";